<ion-header *ngIf="!isEmpty && !isLoading && !error">
  <ion-searchbar placeholder="{{ 'static.search' | translate }}" (ionInput)="filterDocuments($event.target.value)"></ion-searchbar>

  <ion-breadcrumbs>
    <ion-breadcrumb (click)="openRoot()">
      <ion-icon slot="start" name="home"></ion-icon>
      {{ 'Mobile.DocumentsHome' | translate }}
    </ion-breadcrumb>
    <ion-breadcrumb *ngFor="let folder of folderPath" (click)="openFolder(folder)">
      <ion-icon slot="start" name="folder"></ion-icon>
      {{ folder.name }}
    </ion-breadcrumb>
  </ion-breadcrumbs>
</ion-header>

<ion-content class="padding">
  <ion-progress-bar *ngIf="isLoading" type="indeterminate"></ion-progress-bar>

  <div class="error" *ngIf="error !== null">
    <h1 translate>{{ error.type }}</h1>
    <p translate>{{ error.message }}</p>
    <p translate>{{ error.error }}</p>
  </div>

  <div *ngIf="isEmpty" translate>Mobile.NoDocuments</div>

  <ion-list>
    <ion-item *ngFor="let documentItem of documentsFolder.items" (click)="openDocument(documentItem)">
      <ion-icon *ngIf="documentItem.children" name="folder" slot="start"></ion-icon>
      <ion-label text-wrap>
        {{ documentItem.name }}
      </ion-label>
    </ion-item>
  </ion-list>
</ion-content>
